<template>
  <div class="cart-page">
    <div v-if="cartItems.length === 0" class="empty-cart">
      <van-empty image="search" description="购物车是空的" />
    </div>

    <div v-else class="cart-content">
      <div class="cart-list">
        <van-swipe-cell v-for="item in cartItems" :key="item.id">
          <van-card
            :num="item.quantity"
            :price="item.ppAmount"
            :desc="item.goldCoin + '金币'"
            :title="getItemTitle(item)"
            :thumb="item.depositPic"
          >
            <template #tags>
              <van-tag plain type="danger">数量: {{ item.quantity }}</van-tag>
            </template>
            <template #footer>
              <van-stepper
                v-model="item.quantity"
                theme="round"
                min="0"
                @change="(value) => updateQuantity(item.id, value)"
                @minus="onStepperMinus(item.id)"
              />
            </template>
          </van-card>

          <template #right>
            <van-button
              square
              type="danger"
              text="删除"
              @click="removeFromCart(item.id)"
            />
          </template>
        </van-swipe-cell>
      </div>

      <div class="cart-submit">
        <div class="cart-total">
          合计: <span class="price">¥{{ totalAmount }}</span>
        </div>
        <van-button type="primary" @click="checkout">结算</van-button>
      </div>
    </div>


      <van-popup v-model:show="showPayDialog" type="dialog" closeable :close-on-click-overlay="false"
      :style="{ width: '90%', margin: 'auto', borderRadius: '12px' }">
      <div class="pay-method-container">
        <!-- 价格 -->
        <div class="price-header">
          <span class="price-text">¥ {{ totalAmount }}</span>
        </div>

        <!-- 支付方式列表 -->
        <van-radio-group v-model="selectedPayMethod">
          <!-- 微信支付 -->
          <div class="pay-item">
            <div class="pay-icon">
              <img src="@/assets/weixin.png" alt="微信支付" />
            </div>
            <div class="pay-info">
              <div class="pay-name">微信支付</div>
              <div class="pay-desc">请在微信内打开网页支付<van-icon name="question" color="#000" size="18px" style="margin-right:4px" @click="weixinTipClick"/></div>
            </div>
            <van-radio name="wx" />
          </div>

          <!-- 支付宝支付 -->
          <div class="pay-item">
            <div class="pay-icon">
              <img src="@/assets/zhifubao.png" alt="支付宝" />
            </div>
            <div class="pay-info">
              <div class="pay-name">支付宝支付</div>
              <div class="pay-desc">请在浏览器内打开网页支付<van-icon name="question" color="#000" size="18px" style="margin-right:4px" @click="alipayTipClick"/></div>
            </div>
            <van-radio name="zfb" />
          </div>

          <!-- PP币余额 -->
          <div class="pay-item">
            <div class="pay-icon">
              <img src="@/assets/ppb.png" alt="BUFF" width="10px" height="10px" />
            </div>
            <div class="pay-info">
              <div class="pay-name">
                皮皮售余额 (¥ {{ userinfo.accountBalance }})
              </div>
              <div class="pay-desc">
                {{ userinfo.accountBalance < 0 ? "余额不足" : "" }} </div>
              </div>
              <van-radio name="ppb" />
            </div>
        </van-radio-group>

        <!-- 确认付款按钮 -->
        <div class="confirm-btn">
          <van-button type="primary" block @click="confirmPayment" :loading-text="showPayLoadingText"
            :loading="loading">
            确认付款
          </van-button>
        </div>
      </div>
    </van-popup>


    <van-dialog v-model:show="showConfirmDialog" title="支付确认" show-cancel-button @confirm="confirmSubmit"
      @cancel="showConfirmDialog = false" confirm-button-text="确定" cancel-button-text="取消" :before-close="(action) => {
        if (action === 'confirm') {
          return true;
        }
      }
        ">
      <div style="text-align: center">确定支付这笔 ￥{{ totalAmount }} 选中服务吗？</div>
    </van-dialog>

     <van-popup :style="{ height: '70%', width: '100%' }" v-model:show="noticeShow">
      <div v-html="noticeData"></div>
    </van-popup>
  </div>
</template>

<script>
import { showToast } from "vant";
import request from "@/utils/request";

export default {
  name: "CartPage",
  data() {
    return {
      appid: "wx7f7a74f218219cbc",
      userinfo: {},
      showConfirmDialog: false,
      loading: false,
      showPayLoadingText: "",
      showPayDialog: false,
      noticeShow: false,
      noticeData: null,
      cartItems: [],
      selectedPayMethod: '',
    };
  },
  computed: {
    totalAmount() {
      return this.cartItems.reduce(
        (sum, item) => sum + item.ppAmount * item.quantity,
        0
      );
    }
  },
  created() {
    this.userinfo = this.$store.state.user.userInfo;
    this.loadCartItems();
  },
  methods: {
   confirmPayment(){
     this.showConfirmDialog = true;
   },
    weixinTipClick() {
       request.get("/front/chat/keywords", { params: { type: 5 } }).then((res) => {
      if (res.code == 200) {
        this.noticeClick(res.data[0])
      }
    });
    },
    alipayTipClick() {
       request.get("/front/chat/keywords", { params: { type: 6 } }).then((res) => {
      if (res.code == 200) {
        this.noticeClick(res.data[0])
      }
    });
    },
    noticeClick(data) {
      this.noticeData = data.content;
      this.noticeData = this.processHTMLWithStyledImages(this.noticeData);
      this.noticeShow = true;
    },
    onClickLeft() {
      this.$router.back();
    },
    getItemTitle(item) {
      if (item.configDesc) {
        return item.configDesc;
      }
      return item.goldCoin + "金币充值";
    },
    loadCartItems() {
      const cart = localStorage.getItem("cartItems");
      if (cart) {
        this.cartItems = JSON.parse(cart);
      }
    },
    saveCartItems() {
      localStorage.setItem("cartItems", JSON.stringify(this.cartItems));
    },
    updateQuantity(itemId, quantity) {
      const item = this.cartItems.find((item) => item.id === itemId);
      if (item) {
        if (quantity <= 0) {
          this.removeFromCart(itemId);
        } else {
          item.quantity = quantity;
          this.saveCartItems();
        }
      }
    },
    onStepperMinus(itemId) {
      const item = this.cartItems.find((item) => item.id === itemId);
      if (item && item.quantity <= 1) {
        this.removeFromCart(itemId);
      }
    },
    removeFromCart(itemId) {
      this.cartItems = this.cartItems.filter((item) => item.id !== itemId);
      this.saveCartItems();
      showToast("已移除商品");
    },
    checkout() {
      if (this.cartItems.length === 0) {
        showToast("购物车是空的");
        return;
      }
      this.showPayDialog = true;
    },
    //进行支付
    async confirmSubmit() {
      this.showConfirmDialog = false;
      const selectProduct = this.cartItems.map(item => {
        return {
          depositType: item.configType,
          ppAmount: item.ppAmount,
          quantity: item.quantity,
          configDesc: item.configDesc,
          depositPic: item.depositPic,
        }
      })
      
      const params = {
        payType: null,
        payScene: 11,
        gameList: selectProduct,
        totalAmount: this.totalAmount
      }

      if ("wx" == this.selectedPayMethod) {
        if (!this.isInWeixin()) {
          showToast("请在微信内打开网页支付");
          return;
        }
        this.loading = true;
        this.showPayLoadingText = "正在跳转微信支付..."
        params.payType = 1;
        //这是微信支付的
        await this.wxPay(params);
      } else if ("zfb" == this.selectedPayMethod) {
        if (this.isInWeixin()) {
          showToast("请在浏览器内打开网页支付");
          return;
        }
        this.loading = true;
        this.showPayLoadingText = "正在跳转支付宝支付..."
        params.payType = 2;
        //这是支付宝支付的
        await this.zfbPay(params);
      } else {
        this.loading = true;
        this.showPayLoadingText = "正在进行余额支付..."
        params.payType = 3;
        //这是余额支付的
        await this.ppbPay(params);
      }
    },
    async ppbPay(params) {
      // 调用购买API
      request
        .post("/front/pay/create", params)
        .then(async (res) => {
          if (res.code == 200) {
            showToast("支付成功！");
            let ur = await this.$store.dispatch("user/getUserInfo");
            if (ur.code == 200) {
              this.userinfo = res.data;
              this.clearCart();
            }
            this.startChat();
          } else {
            showToast(res.msg);
          }
        }).finally(() => {
          this.loading = false;
          this.showPayDialog = false;
        })
    },
    async zfbPay(params) {
      try {
        const result = await request.post("/front/pay/create", params);
        if (result.code === 200) {
          const payFormPage = result.data.pageRedirection;
          this.handleAlipaySubmit(payFormPage);
        }
      } catch (error) {
        showToast("支付失败，请重试!");
      } finally {
        this.loading = false;
        this.showPayDialog = false;
      }
    },

    handleAlipaySubmit(htmlForm) {
      // 创建一个临时容器
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = htmlForm;

      // 获取表单元素
      const form = tempDiv.querySelector("form");
      if (form) {
        // 添加到页面并提交
        document.body.appendChild(form);
        form.submit();
      } else {
        showToast("支付失败!");
      }
    },
    async wxPay(params) {
      if (this.userinfo.openId) {
        params.openid = this.userinfo.openId;
        this.wxPayment(params)
      } else {
        // 将state数据编码为JSON字符串并进行URL编码
        const stateParam = encodeURIComponent(JSON.stringify(params));
        // console.log(stateParam);
        // 使用正确的重定向URL格式
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appid
          }&redirect_uri=${encodeURIComponent(
            `https://www.ppstandoff2.com/proxyPlay`
          )}&response_type=code&scope=snsapi_base&state=${stateParam}#wechat_redirect`;
      }
    },
    async wxPayment(params) {
      const res_createOrder = await request.post(
        "/front/pay/create", params);
      if (res_createOrder.code == 200) {
        if (typeof WeixinJSBridge === "undefined") {
          showToast("请在微信中打开");
        } else {
          WeixinJSBridge.invoke(
            "getBrandWCPayRequest",
            {
              appId: this.appid,
              timeStamp: res_createOrder.data.payParams.timeStamp,
              nonceStr: res_createOrder.data.payParams.nonceStr,
              package: res_createOrder.data.payParams.packageVal,
              signType: res_createOrder.data.payParams.signType,
              paySign: res_createOrder.data.payParams.paySign,
            },
            async (res) => {
              if (res.err_msg === "get_brand_wcpay_request:ok") {
                showToast("支付成功");
                this.loading = false;
                this.showPayDialog = false;
                this.clearCart();
                this.startChat();
              }
              else if (res.err_msg === "get_brand_wcpay_request:cancel") {
                showToast("用户取消支付");
                this.loading = false;
                this.showPayDialog = false;
              }
              else {
                showToast("支付失败");
                this.loading = false;
                this.showPayDialog = false;
              }
            }
          );
        }
      }
    },
    async registerAuthCallBack() {
      const url = new URL(window.location.href);
      const code = url.searchParams.get("code");
      const state = url.searchParams.get("state");
      const payScene = url.searchParams.get("payScene");
      console.log(`code=${code}, state=${state}, payScene=${payScene}`)
      if (code) {
        console.log("微信授权回调")
        try {
          // 先解码，再解析JSON
          const decodedState = decodeURIComponent(state);
          const stateData = JSON.parse(decodedState);
          console.log(stateData);
          const res_openid = await request.get(
            "/front/auth/wechat/auth/callback",
            {
              params: { code: code },
            }
          );
          let openid = res_openid.data;
          stateData.openid = openid
          this.userinfo.openId = openid;
          this.wxPayment(stateData);
        } catch (error) {
          console.error("解析state参数失败:", error);
          showToast("微信支付失败,请稍后重试");
        }
      }
      if (payScene) {
        this.startChat();
      }
    },
    isInWeixin() {
      const judgeIfWeXin = typeof WeixinJSBridge == "undefined";
      return !judgeIfWeXin;
    },
    extractAndStyleImages(htmlString) {
      // 匹配所有img标签的正则表达式
      const imgRegex = /<img[^>]+src="([^">]+)"[^>]*>/g;
      const images = [];
      let match;

      // 提取所有img标签
      while ((match = imgRegex.exec(htmlString)) !== null) {
        images.push({
          originalTag: match[0], // 原始img标签
          src: match[1], // 图片地址
          index: match.index, // 在字符串中的位置
        });
      }

      return images;
    },
    processHTMLWithStyledImages(htmlString) {
      // 提取所有图片
      const images = this.extractAndStyleImages(htmlString);
      let processedHTML = htmlString;

      // 为每个img标签添加样式
      images.forEach((img) => {
        const styledImgTag = `<img src="${img.src}" style="max-width: 100%; height: auto;" alt="饰品图片">`;
        processedHTML = processedHTML.replace(img.originalTag, styledImgTag);
      });

      return processedHTML;
    },
    clearCart() {
      this.cartItems = [];
      localStorage.removeItem("cartItems");
    },
  },
};
</script>

<style scoped>
.cart-page {
  background-color: #f7f8fa;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.empty-cart {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
}

.cart-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

  .cart-list {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 10px;
  padding-bottom: 100px;
}

/* 美化购物车 item 样式 */
.cart-list .van-swipe-cell {
  margin-bottom: 12px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.cart-list .van-swipe-cell:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

.cart-list .van-card {
  background: white;
  border-radius: 12px;
  padding: 12px;
}

.cart-list .van-card__header {
  align-items: center;
}

.cart-list .van-card__thumb {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  overflow: hidden;
}

.cart-list .van-card__content {
  padding-left: 12px;
}

.cart-list .van-card__title {
  font-size: 14px;
  font-weight: 600;
  color: #323233;
  margin-bottom: 4px;
}

.cart-list .van-card__desc {
  font-size: 12px;
  color: #969799;
  margin-bottom: 8px;
}

.cart-list .van-card__bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cart-list .van-card__price {
  color: #ee0a24;
  font-weight: bold;
}

.cart-list .van-card__num {
  color: #969799;
  font-size: 12px;
}

.cart-list .van-card__footer {
  padding-top: 8px;
  border-top: 1px solid #f5f5f5;
  margin-top: 8px;
}

/* 调整 stepper 样式 */
.cart-list .van-stepper {
  display: flex;
  justify-content: flex-end;
}

.cart-list .van-stepper__input {
  background: #f7f8fa;
  border-radius: 4px;
}

.cart-list .van-stepper__minus,
.cart-list .van-stepper__plus {
  background: #f7f8fa;
  border-radius: 4px;
}

.cart-submit {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  background-color: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 100;
}

.cart-total {
  font-size: 16px;
  font-weight: bold;
}

.price {
  color: #ee0a24;
  font-size: 18px;
}
.pay-method-container {
  padding: 20px;
  background: white;
  border-radius: 12px;
}

.price-header {
  text-align: center;
  font-size: 24px;
  color: #333;
  margin-bottom: 20px;
}
.pay-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
  border-bottom: 1px solid #eee;
  cursor: pointer;
}

.pay-item:last-child {
  border-bottom: none;
}

.pay-item.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.pay-icon {
  width: 40px;
  height: 40px;
  /* border-radius: 50%; */
  overflow: hidden;
  /* background: #f5f5f5; */
  display: flex;
  align-items: center;
  justify-content: center;
}

.pay-icon img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.pay-info {
  flex: 1;
  margin-left: 12px;
}

.pay-name {
  font-size: 16px;
  color: #333;
}

.pay-desc {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}

.confirm-btn {
  margin-top: 20px;
}
</style>
